import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmarkCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	className: "svg-icon",
	focusable: "false",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "m18 9-1.4-1.5-6 6-3.2-3L6 11.8l4.6 4.6L18 9z" }), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
		clipRule: "evenodd"
	})]
});
export default SvgCheckmarkCircle;
